import { message } from 'antd';
import { config } from 'util/config';
import { httpClient, uploadClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });

  httpClient
    .get('/System/SelectOption/GetStateListByModuleId?id=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ stateData: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  httpClient
    .get('/Admin/Lga/GetSelectOptionList?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ lgaData: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  httpClient
    .get('/System/AuSuburb/GetSelectOptionList?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ suburbData: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

//点击修改密码按钮
export function changePassword({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModalChangePassword: true, companyUserId: parameter.CompanyUserId });
}

//修改密码提交表单
export function submitChangePassword({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ changePasswordFormSubmitting: true });
  var form = pageComponent.formRef.current?.getFieldsValue();
  httpClient
    .post('Admin/CompanyUser/ChangePassword/' + pageComponent.state.companyUserId, form)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.formRef.current?.resetFields();
        pageComponent.setState({ showModalChangePassword: false, changePasswordFormSubmitting: false });
        message.success('Reset password successful');
      } else {
        globalFunction.handleResultError(data, pageComponent);
        pageComponent.setState({ changePasswordFormSubmitting: false });
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      pageComponent.setState({ changePasswordFormSubmitting: false });
    });
}

//点击打开Registration界面
export function manageRegistration({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModalManageRegistration: true, companyUserId: parameter.CompanyUserId });
  pageComponent.getRegistrationData(parameter.CompanyUserId);
}

//Registration提交表单
export function submitRegistrationForm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ registrationFormSubmitting: true });
  var form = pageComponent.registrationFormRef.current?.getFieldsValue();
  form.CompanyUserId = pageComponent.state.companyUserId;
  switch (pageComponent.state.componentType) {
    case 'Create':
      httpClient
        .post('/Admin/CompanyUserRegNo/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.registrationFormRef.current?.resetFields();
            pageComponent.setState({ registrationFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalRegistrationForm: false, componentType: '' });
              pageComponent.getRegistrationData(pageComponent.state.companyUserId);
              pageComponent.createPage.current?.child[0].current?.getSectionDataByDefault();
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ registrationFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ registrationFormSubmitting: false });
        });
      break;
    case 'Edit':
      form.key = pageComponent.state.companyUserRegNoId;
      httpClient
        .put('/Admin/CompanyUserRegNo/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.registrationFormRef.current?.resetFields();
            pageComponent.setState({ registrationFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalRegistrationForm: false, componentType: '' });
              pageComponent.getRegistrationData(pageComponent.state.companyUserId);
              pageComponent.createPage.current?.child[0].current?.getSectionDataByDefault();
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ registrationFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ registrationFormSubmitting: false });
        });
      break;
  }
}

//Availability弹框
export function showAvailability({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showModalAvailableDates: true, companyUserId: parameter.CompanyUserId, availabilityTitle: parameter.Name + ' - Not Available Dates' });
  pageComponent.getAvailabilityData(parameter.CompanyUserId);
}

//Availability提交表单
export function submitAvaiableForm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ availableFormSubmitting: true });
  const isCrossingMidnight = !pageComponent.availableFormRef.current?.getFieldsValue().Date[0].isSame(pageComponent.availableFormRef.current?.getFieldsValue().Date[1], 'day');
  var form = pageComponent.availableFormRef.current?.getFieldsValue();
  form.StartDate = pageComponent.availableFormRef.current?.getFieldsValue().Date[0].format("DD/MM/YYYY HH:mm")
  form.EndDate = pageComponent.availableFormRef.current?.getFieldsValue().Date[1].format("DD/MM/YYYY HH:mm")
  form.CompanyUserId = pageComponent.state.companyUserId;
  if (!form.Repeat) {
    form.Type = null
    form.Times = 0
  }
  if (form.Type === 'Daily' && isCrossingMidnight) {
    message.warning('To add Avaiable time block, please set Start and End date as the same day.');
    pageComponent.setState({ availableFormSubmitting: false });
    return
  }

  switch (pageComponent.state.componentType) {
    case 'Create':
      httpClient
        .post('/Admin/CompanyUserNotAvailability/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.availableFormRef.current?.resetFields();
            pageComponent.setState({ availableFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalAvailableDatesForm: false, componentType: '' });
              pageComponent.getAvailabilityData(pageComponent.state.companyUserId);

              if (pageComponent.createPage.current?.child[0].current != null && pageComponent.createPage.current?.child[0].current?.props.section.name === 'ExternalContractor') {
                pageComponent.createPage.current?.child[0].current?.getSectionDataByDefault();
              }
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            pageComponent.setState({ availableFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          pageComponent.setState({ availableFormSubmitting: false });
        });
      break;
    case 'Edit':
      form.key = pageComponent.state.companyUserRegNoId;
      httpClient
        .put('/Admin/CompanyUserNotAvailability/', form)
        .then(({ data }) => {
          if (data.result) {
            pageComponent.availableFormRef.current?.resetFields();
            pageComponent.setState({ availableFormSubmitting: false });
            setTimeout(() => {
              pageComponent.setState({ showModalAvailableDatesForm: false, componentType: '' });
              pageComponent.getAvailabilityData(pageComponent.state.companyUserId);

              if (pageComponent.createPage.current?.child[0].current != null && pageComponent.createPage.current?.child[0].current?.props.section.name === 'ExternalContractor') {
                pageComponent.createPage.current?.child[0].current?.getSectionDataByDefault();
              }
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data);
            pageComponent.setState({ availableFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          pageComponent.setState({ availableFormSubmitting: false });
        });
      break;
  }
}

export function addExternalContractorPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource.LgaIdList = pageComponent.state.lgaData;
  componentDataSource.AuSuburbIdList = pageComponent.state.suburbData;
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

export function editExternalContractorPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource.LgaIdList = pageComponent.state.lgaData;
  componentDataSource.AuSuburbIdList = pageComponent.state.suburbData;
  sectionComponent.customForm.current?.setState({ componentDataSource });
}
// Suburb
export function showSuburb({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  const availableSuburbIdSet = new Set((pageComponent.state.suburbData || []).map(c => Number(c.Value)));
  if (availableSuburbIdSet.size === 0) {
    message.warning('Please select a module before managing Council or Suburb.');
    return;
  }

  pageComponent.setState({ SuburbLoading: true });
  Promise.all([
    httpClient.get('/Admin/ExternalContractor/' + parameter.key),
    httpClient.get('/System/AuSuburb/GetList')
  ])
    .then(([contractorResponse, suburbResponse]) => {
      if (!contractorResponse.data.result) {
        globalFunction.handleResultError(contractorResponse.data, pageComponent);
        return;
      }
      if (!suburbResponse.data.result) {
        globalFunction.handleResultError(suburbResponse.data, pageComponent);
        return;
      }

      const suburbList = suburbResponse.data.data.filter(c => availableSuburbIdSet.has(Number(c.AuSuburbId)));
      pageComponent.setState({
        showModalSuburb: true,
         SuburbLoading: false,
         SuburbContractorId: parameter.key,
         SuburbTitle: parameter.Name + ' - Suburb',
        selectedLgaIdList: contractorResponse.data.data.LgaIdList || [],
        selectedAuSuburbIdList: contractorResponse.data.data.AuSuburbIdList || [],
         SuburbData: suburbList
      });
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      pageComponent.setState({  SuburbLoading: false });
    });
}